module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Accordion ใช้สำหรับ เปิด/ปิด การแสดงผล Content ภายใน\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicZIndex'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Z Index\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentBreadcrumb'
      }
    }
  }, [_vm._v("\n            Breadcrumb   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#component-accordion"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Accordion\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class ที่เกี่ยวข้อง")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-accordion")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-accordion-content")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_vm._v("\n        ใช้งานร่วมกับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("<input>")]), _vm._v(" ได้สองแบบ\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('strong', [_vm._v("Checkbok")]), _vm._v(" (เปิดหลาย Accordion ได้พร้อมกัน)")]), _vm._v(" "), _c('li', [_vm._v("• "), _c('strong', [_vm._v("Radio")]), _vm._v(" (เปิดทีละ Accordion)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-64px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-accordion")])])]), _vm._v(" "), _c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".-has-icon")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-accordion-content")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Accordion แบบ Checkbox")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-accordion\">\n  <input id=\"ac1\" type=\"checkbox\">\n  <label for=\"ac1\"><strong>Accordion checkbox 1</strong></label>\n  <div class=\"bio-accordion-content\">\n    <div>Item A</div>\n    <div>Item B</div>\n    <div>Item C</div>\n  </div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-accordion"
  }, [_c('input', {
    attrs: {
      "id": "ac1",
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ac1"
    }
  }, [_c('strong', [_vm._v("Accordion checkbox 1")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content"
  }, [_c('div', [_vm._v("Item A")]), _vm._v(" "), _c('div', [_vm._v("Item B")]), _vm._v(" "), _c('div', [_vm._v("Item C")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่าง Accordion ที่ใช้ ")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".-has-icon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Accordion – With Icon -->\n<div class=\"bio-accordion -has-icon _mgbt-32px\">\n  <input id=\"ac2\" type=\"checkbox\" class=\"_dp-n\">\n  <label for=\"ac2\"><strong>Accordion checkbox 2</strong></label>\n  <div class=\"bio-accordion-content\">\n    <div class=\"bio-link -item\">Item A</div>\n    <div class=\"bio-link -item\">Item B</div>\n    <div class=\"bio-link -item\">Item C</div>\n  </div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-accordion -has-icon"
  }, [_c('input', {
    attrs: {
      "id": "ac2",
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ac2"
    }
  }, [_c('strong', [_vm._v("Accordion checkbox 2")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content"
  }, [_c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item A")]), _vm._v(" "), _c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item B")]), _vm._v(" "), _c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item C")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่าง Accordion แบบ Radio")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Accordion – With Icon -->\n<div class=\"bio-accordion\">\n  <input id=\"ar1\" type=\"radio\" name=\"ar\" class=\"_dp-n\">\n  <label for=\"ar1\"><strong>Accordion radio 1</strong></label>\n  <div class=\"bio-accordion-content\">\n    <div>Item A</div>\n    <div>Item B</div>\n    <div>Item C</div>\n  </div>\n</div>\n\n<div class=\"bio-accordion\">\n  <input id=\"ar2\" type=\"radio\" name=\"ar\" class=\"_dp-n\">\n  <label for=\"ar2\"><strong>Accordion radio 2</strong></label>\n  <div class=\"bio-accordion-content\">\n    <div>Item A</div>\n    <div>Item B</div>\n    <div>Item C</div>\n  </div>\n</div>\n\n<div class=\"bio-accordion\">\n  <input id=\"ar3\" type=\"radio\" name=\"ar\" class=\"_dp-n\">\n  <label for=\"ar3\"><strong>Accordion radio 3</strong></label>\n  <div class=\"bio-accordion-content\">\n    <div>Item A</div>\n    <div>Item B</div>\n    <div>Item C</div>\n  </div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-accordion _mgbt-8px"
  }, [_c('input', {
    attrs: {
      "id": "ar1",
      "type": "radio",
      "name": "ar"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ar1"
    }
  }, [_c('strong', [_vm._v("Accordion radio 1")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content"
  }, [_c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item A")]), _vm._v(" "), _c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item B")]), _vm._v(" "), _c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item C")])])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion _mgbt-8px"
  }, [_c('input', {
    attrs: {
      "id": "ar2",
      "type": "radio",
      "name": "ar"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ar2"
    }
  }, [_c('strong', [_vm._v("Accordion radio 2")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content"
  }, [_c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item A")]), _vm._v(" "), _c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item B")]), _vm._v(" "), _c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item C")])])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion"
  }, [_c('input', {
    attrs: {
      "id": "ar3",
      "type": "radio",
      "name": "ar"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ar3"
    }
  }, [_c('strong', [_vm._v("Accordion radio 3")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-accordion-content"
  }, [_c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item A")]), _vm._v(" "), _c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item B")]), _vm._v(" "), _c('div', {
    staticClass: "bio-link -item"
  }, [_vm._v("Item C")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16b4680e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/ComponentAccordion.vue
// module id = 113
// module chunks = 0